export const TABLE_HEADERS = {
  REF_NUMBER: "Reference No",
  REQUEST_TYPE: "Request Type",
  USER: "User",
  SYSTEM_CATEGORY: "System Category",
  NAME: "Name",
  ENVIRONMENT: "Environment",
  ROLE: "Role",
  EFFECTIVE_DATE: "Effective Date",
  STATUS: "Status",
  DEVICE_TYPE: "Device Type",
  REQUESTED_BY: "Requested By",
  DATE_REQUESTED: "Date Requested",
  USER_EMAIL: "User Email",
  DATE_ADDED: "Date Added",
  RF_NO: "RF No",
  BUSSINES_UNIT: "Bussines Unit",
  REQUESTOR: "Requestor",
};

export const TOOLTIPS = {
  NAME: "System, Device, Server, Database, Network",
};
